export default __webpack_public_path__ + "static/media/ChowHing-Yaung.2438821f.png";